module.exports = __webpack_public_path__ + "static/img/伙伴客户-贵州医科大附二.e703e9fd.png";